import React, { Fragment, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Svg } from 'app/components';
import { LineBordered, Seats, SeatsAfterSelections, SeatsItem, Total } from './styles';
import { useConfig, usePayment } from 'app/hooks';
import { SeatPlanNote } from '../../purchase/StepSeats/styles';
import { RowButton, } from '../../purchase/styles';
import { Button } from 'app/components';
import { useCallback } from 'react';
import { useContext } from 'react';
import ConfigContext from 'app/context/config';
import { generatePath, useHistory, useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { buyRequest } from "../../../../app/store/payment/actions"
const propTypes = {
  screenName: PropTypes.string.isRequired,
  isBonus: PropTypes.bool,
  row: PropTypes.string.isRequired,
  totalPrice: PropTypes.number.isRequired,
  seats: PropTypes.string.isRequired,
  seatsDescription: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      amount: PropTypes.number.isRequired
    })
  ).isRequired,

  withDescription: PropTypes.bool,
  withTotalIcon: PropTypes.bool,

  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  buy: PropTypes.func.isRequired,
};

const defaultProps = {
  withDescription: true,
  withTotalIcon: true,
  isBonus: false
};
const SelectionTotal = ({
  screenName,
  row,
  seats,
  totalPrice,
  seatsDescription,
  withDescription,
  withTotalIcon,
  isBonus,
  buy
}) => {
  const [t, i18n] = useTranslation();
  const { language } = i18n;
  const sessionData = useSelector(state => state.sessions);
  const bookingData = useSelector(state => state?.bookings?.booking?.concessions);
  const orderData = useSelector(state => state.order);
  const { currencyForCountry } = useConfig()
  const orderConcessionItemsData = useSelector(state => state?.concessions?.concessionItem);
  const orderConcessionComboItemsData = useSelector(state => state?.concessions?.concessionComboItem);
  const orderConcessionItem = orderConcessionItemsData?.orderConcessionItem;
  const orderConcessionComboItem = orderConcessionComboItemsData?.orderConcessionItem;
  // const totalPriceData = orderConcessionItemsData ? orderTotalValueInCents / 100 : totalPrice / 100;
  // const totalPriceData = orderConcessionComboItemsData ? orderComboTotalValueInCents / 100 : totalPrice / 100;
  const orderTotalValueInCents = orderConcessionItemsData?.orderTotalValueInCents;
  const orderComboTotalValueInCents = orderConcessionComboItemsData?.orderTotalValueInCents;
  const totalConcessionOrder = orderTotalValueInCents + orderComboTotalValueInCents - totalPrice;
  const bothConcessionOrder = Object?.keys(orderConcessionItemsData || {})?.length > 0 && Object?.keys(orderConcessionComboItemsData || {})?.length > 0;
  const totalPriceData = (bothConcessionOrder) ? totalConcessionOrder / 100 : orderConcessionItemsData ? orderTotalValueInCents / 100 : orderConcessionComboItemsData ? orderComboTotalValueInCents / 100 : totalPrice / 100;
  const totalPriceSet = totalPriceData.toFixed(2).replace('.', ',');
  const { routes } = useContext(ConfigContext);
  const bonusPriceData = sessionData?.session?.userBalance?.cardBalance;
  const bonusPriceSet = bonusPriceData?.toFixed(2).replace('.', ',');
  const location = useLocation();
  const cinemas = useSelector(state => state?.cinemas?.cinemas);
  const country = process.env.REACT_APP_COUNTRY;

  // Function to remove duplicates and sum quantities
  function removeDuplicatesAndSumQuantities(items) {
    const itemMap = {};
    items.forEach(item => {
      if (itemMap[item.itemId]) {
        itemMap[item.itemId].quantity += item.quantity;
      } else {
        itemMap[item.itemId] = { ...item };
      }
    });
    return Object.values(itemMap);
  }

  const orderConcessionItemData = orderConcessionItem && removeDuplicatesAndSumQuantities(orderConcessionItem);
  const orderConcessionComboItemData = orderConcessionComboItem && removeDuplicatesAndSumQuantities(orderConcessionComboItem);

  const concessionsaleData = cinemas?.filter((item) => {
    const cinemaId = location?.pathname?.split("/")[3]?.split('-')[0];
    return item?.id === cinemaId;
  });

  // const next = useCallback(() => {
  //   concessionsaleData[0]?.concessionsale
  //     ? history.push(generatePath(routes.stepSnacksAndDrinks.pattern, { movieCinemaId }))
  //     : history.push(generatePath(routes.stepCheckout.pattern, { movieCinemaId }))
  // }, [movieCinemaId]);
  const email = location?.state?.email;
  const movieCinemaId = sessionStorage.getItem("movieCinemaId");
  const history = useHistory();
  const next = useCallback(() => {

    if (email && orderData) {
      buy(orderData?.userSessionId, email);
    }
    else if (country === 'aut' && concessionsaleData && concessionsaleData[0]?.concessionsale) {
      history.push(generatePath(routes.stepSnacksAndDrinks.pattern, { movieCinemaId }))
    }
    else {
      // history.push(generatePath(routes.stepCheckout.pattern, { movieCinemaId }));
      history.push({
        pathname: generatePath(routes.stepCheckout.pattern, { movieCinemaId }),
        state: { isAboId: location?.state?.isAboId }
      });
    }
    // eslint-disable-next-line
  }, [movieCinemaId, orderData]);

  const currencyForCountryData = value => {
    switch (value) {
      case 'bih': {
        return 'KM';
      }

      case 'rou': {
        return 'LEI';
      }

      case 'aut': {
        return 'EUR';
      }

      case 'srb': {
        return 'RSD';
      }

      case 'alb': {
        return 'ALL';
      }

      case 'bil': {
        return 'KM';
      }

      case 'grc': {
        return '€';
      }

      case 'hrv': {
        return '€';
      }

      case 'mkd': {
        return 'ДЕН';
      }

      case 'mne': {
        return '€';
      }

      case 'rks': {
        return '€';
      }

      case 'svn': {
        return '€';
      }

      default: {
        return '';
      }
    }
  };
  const languageContents = useMemo(
    () => ({
      description: language === 'en' ? 'DescriptionAlt' : 'Description'
    }),
    [language]
  );

  // Function to remove duplicates based on "ItemId" and aggregate "QuantityBooked"
  function removeDuplicatesAndAggregate(array) {
    const itemMap = {};
    array.forEach((item) => {
      const itemId = item?.ItemId;
      if (!itemMap[itemId]) {
        itemMap[itemId] = { ...item };
      } else {
        itemMap[itemId].QuantityBooked += item?.QuantityBooked;
      }
    });

    return Object.values(itemMap);
  }

  const newArray = bookingData && removeDuplicatesAndAggregate(bookingData);


  return (
    <Fragment>
      <Seats>
        <SeatsItem>{screenName}</SeatsItem>
        <SeatsItem>
          {t('purchase.row')} {row}
        </SeatsItem>
        <SeatsItem>
          {t('purchase.seats')} {seats}
        </SeatsItem>
      </Seats>

      {withDescription ? (
        <Fragment>
          {seatsDescription.map(seat => {
            const dataPrice = seat.price / 100;
            const PriceSet = dataPrice.toFixed(2).replace('.', ',');
            const sessions = orderData?.seasonPassSessions;
            const totalSessions = sessions != null && sessions.length > 0 ? sessions.length : 1;
            //  return (
            //     <>
            //       <LineBordered key={seat.title}>
            //         <span>{seat.title}</span>
            //         <span>{seat.amount} X {process.env.REACT_APP_COUNTRY === 'aut' ? currencyForCountry : ''} {PriceSet} {process.env.REACT_APP_COUNTRY !== 'aut' ? currencyForCountryData(process.env.REACT_APP_COUNTRY) : ''}</span>
            //       </LineBordered>
            //     </>
            //     )      
            return (
              <div>
                {email || location?.state?.isAboId ? <LineBordered>
                  <span>{totalSessions} {t('purchase.sessions')}, {(seat?.amount / totalSessions)} {t('purchase.seats')}, {process.env.REACT_APP_COUNTRY === 'aut' ? currencyForCountry : ''} {PriceSet} {process.env.REACT_APP_COUNTRY !== 'aut' ? currencyForCountryData(process.env.REACT_APP_COUNTRY) : ''}</span>
                </LineBordered> : null}
                <LineBordered key={seat.title}>
                  <span>{seat.title}</span>
                  {email || location?.state?.isAboId ? <span>{totalSessions}  X {(seat?.amount / totalSessions)} X {process.env.REACT_APP_COUNTRY === 'aut' ? currencyForCountry : ''} {PriceSet} {process.env.REACT_APP_COUNTRY !== 'aut' ? currencyForCountryData(process.env.REACT_APP_COUNTRY) : ''}</span> :
                    <span>{seat.amount} X {process.env.REACT_APP_COUNTRY === 'aut' ? currencyForCountry : ''} {PriceSet} {process.env.REACT_APP_COUNTRY !== 'aut' ? currencyForCountryData(process.env.REACT_APP_COUNTRY) : ''}</span>}
                </LineBordered>
              </div>
            );
          })}


          {orderConcessionItemData?.map(item => {
            const dataPrice = item.finalPriceInCents / 100;
            const PriceSet = dataPrice?.toFixed(2).replace('.', ',');
            return (
              <LineBordered key={item?.itemId}>
                <span>{item?.description}</span>
                <span>{item?.quantity}  X {process.env.REACT_APP_COUNTRY === 'aut' ? currencyForCountry : ''} {PriceSet} {process.env.REACT_APP_COUNTRY !== 'aut' ? currencyForCountryData(process.env.REACT_APP_COUNTRY) : ''}</span>
              </LineBordered>
            )
          })}

          {orderConcessionComboItemData?.map(item => {
            const dataPrice = item.finalPriceInCents / 100;
            const PriceSet = dataPrice?.toFixed(2).replace('.', ',');
            return (
              <LineBordered key={item?.itemId}>
                <span>{item?.description}</span>
                <span>{item?.quantity}  X {process.env.REACT_APP_COUNTRY === 'aut' ? currencyForCountry : ''} {PriceSet} {process.env.REACT_APP_COUNTRY !== 'aut' ? currencyForCountryData(process.env.REACT_APP_COUNTRY) : ''}</span>
              </LineBordered>
            )
          })}
          {newArray?.map(seat => {
            const dataPrice = seat?.PriceInCents / 100;
            const PriceSet = dataPrice?.toFixed(2).replace('.', ',');
            // const description = seat?.[languageContents?.description];
            const description = seat?.Description;
            return (
              <LineBordered key={seat?.description}>
                <span>{description}</span>
                <span>{seat?.QuantityBooked} X {process.env.REACT_APP_COUNTRY === 'aut' ? currencyForCountry : ''} {PriceSet} {process.env.REACT_APP_COUNTRY !== 'aut' ? currencyForCountryData(process.env.REACT_APP_COUNTRY) : ''}</span>
              </LineBordered>
            );
          })}

          <LineBordered>
            <Total>
              {withTotalIcon ? <Svg id="cart" /> : null}
              <span>{t('purchase.total')}:</span>
            </Total>

            <strong>
              {process.env.REACT_APP_COUNTRY === 'aut' ? currencyForCountry : ''} {totalPriceSet} {process.env.REACT_APP_COUNTRY !== 'aut' ? currencyForCountryData(process.env.REACT_APP_COUNTRY) : ''}
            </strong>
          </LineBordered>

          {isBonus && (
            <LineBordered>
              <h3>{t('common.credit_bonus_card')}</h3>
              <h3 className={classNames({ invalid: sessionData?.session?.userBalance?.cardBalance < totalPrice / 100 })}>
                {currencyForCountry} {bonusPriceSet}
              </h3>
            </LineBordered>
          )}
          {
            isBonus ?
              <div>
                {
                  location.pathname.split("/")[4] === 'seats' ?
                    <>
                      <RowButton>
                        <Button isPrimary disabled={(sessionData?.session?.userBalance?.cardBalance < (totalPrice / 100))} onClick={next}>
                          {t('purchase.next')}
                        </Button>
                      </RowButton>
                      {
                        sessionData?.session?.userBalance?.cardBalance < totalPrice / 100 ?
                          (
                            <span style={{ color: "#de1619" }}>
                              {t('purchase.bonus_card_less_balance')}
                            </span>
                          )
                          : ""
                      }
                      <SeatPlanNote>
                        {t('purchase.plan_note')}
                      </SeatPlanNote>
                    </>
                    :
                    null
                }
              </div>
              :
              <>
                {
                  location.pathname.split("/")[4] === 'seats' ?
                    <SeatsAfterSelections>
                      <RowButton>
                        <Button isPrimary onClick={next}>
                          {!email ? t('purchase.next') : t('purchase.pay')}
                        </Button>
                      </RowButton>
                      <SeatPlanNote>{t('purchase.plan_note')}</SeatPlanNote>
                    </SeatsAfterSelections>
                    :
                    null
                }
              </>
          }
        </Fragment>
      ) :
        null
      }

    </Fragment >
  );
};

SelectionTotal.defaultProps = defaultProps;
SelectionTotal.propTypes = propTypes;
export default SelectionTotal;
